import {LocationsService} from './locations';
import {SessionService} from './session';
import {BackendModule} from '../modules/backend.module';
import {Injectable} from '@angular/core';
import {Geolocation} from '@ionic-native/geolocation';

declare var google: any;

@Injectable()
export class BeautyMapService {
  //initial location set to Auditorio Nacional
  lastSelectedMarker: any = null;

  searchText: string = '';

  defaultLocation = this.locationsService.translate('defaultLocation');

  myLocation = this.defaultLocation;

  cities = [];
  cityId = '';

  constructor(
    public geolocation: Geolocation,
    public backendModule: BackendModule,
    public sessionService: SessionService,
    public locationsService: LocationsService
  ) {
  }

  getDistance(lat, lng) {
    let from = new google.maps.LatLng(lat, lng);
    let to = new google.maps.LatLng(this.myLocation.lat, this.myLocation.lng);
    let dist = google.maps.geometry.spherical.computeDistanceBetween(from, to);
    let km = (dist / 1000).toFixed(1);
    return km;
  }

  //gets your location
  getLocation = () => {
    return new Promise((resolve, reject) => {
      if (this.defaultLocation.lat === this.myLocation.lat) {
        this.geolocation
          .getCurrentPosition({timeout: 5000})
          .then(resp => {
            this.myLocation = {
              lat: resp.coords.latitude,
              lng: resp.coords.longitude
            };
            resolve();
          })
          .catch(err => {
            reject(err);
          });
      }
    });
  };

  getCities() {
    this.backendModule.getAPI('cities').subscribe(
      (response: any) => {
        console.log('=> Cities', response)
        this.cities = response.filter(city => city.active);
        this.cityId = this.cities[0].id;
      },
      err => {
        this.sessionService.reportError('mapService', 'getCities()', err);
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/services/beauty-map.ts